import React from "react";
import Link from "../../utils/link";
import { graphql, useStaticQuery } from "gatsby";

import useStoryblok from "../../lib/storyblok";

function StackedLogo(props) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0.01 1450.4 493.78"
      {...props}
    >
      <defs>
        <style>{".cls-2{fill:white}"}</style>
      </defs>
      <path
        className="cls-2"
        d="M58.1 39.23H0V2.4h158.11v36.83h-58.1v166.8H58.1V39.23zM188.93 2.4h75.46c41.63 0 75.77 19.47 75.77 67.08 0 30.84-16.17 50.31-39.83 59.59l46.42 76.97h-47.91l-41.33-70.67h-26.66v70.67h-41.92V2.4zm74.27 97.62c20.67 0 33.84-8.09 33.84-30.54s-13.78-30.25-33.84-30.25h-32.34v60.79h32.34zM373.38 132.36V2.4h41.92v127.57c0 29.65 12.87 41.02 40.73 41.02s40.13-11.37 40.13-41.02V2.4h41.92v129.96c0 51.51-35.64 76.37-82.05 76.37s-82.65-24.86-82.65-76.37zM560.51 165.9l34.14-19.76c8.98 14.68 20.66 25.46 41.33 25.46 17.37 0 28.44-8.69 28.44-20.67 0-14.37-11.37-19.47-30.54-27.85l-10.49-4.49c-30.24-12.87-50.31-29.05-50.31-63.18 0-31.45 23.96-55.4 61.39-55.4 26.66 0 45.82 9.28 59.6 33.54l-32.64 20.96c-7.19-12.88-14.98-17.97-26.96-17.97s-20.06 7.79-20.06 17.97c0 12.58 7.79 17.67 25.75 25.45l10.49 4.5c35.63 15.28 55.69 30.85 55.69 65.88 0 37.73-29.64 58.4-69.47 58.4s-64.08-18.57-76.36-42.83zM779.4 39.23h-58.1V2.4h158.11v36.83h-58.1v166.8h-41.92V39.23zM11.68 287.45h71.57c41.62 0 75.77 20.67 75.77 68.28s-34.44 68.58-75.77 68.58H53.61v66.78H11.68V287.46zm70.37 100.02c20.67 0 33.84-9.29 33.84-31.74s-13.78-31.45-33.84-31.45H53.61v63.19h28.44zM191.63 287.45h75.46c41.63 0 75.77 19.47 75.77 67.08 0 30.84-16.17 50.31-39.83 59.59l46.42 76.97h-47.91l-41.33-70.67h-26.66v70.67h-41.92V287.46zm74.27 97.62c20.67 0 33.84-8.09 33.84-30.54s-13.78-30.25-33.84-30.25h-32.34v60.79h32.34zM371.58 389.26c0-60.2 46.72-104.52 105.41-104.52S582.4 329.06 582.4 389.26s-46.72 104.52-105.41 104.52-105.41-44.32-105.41-104.52zm167.7 0c0-38.03-25.15-67.08-62.29-67.08s-62.29 29.05-62.29 67.08 25.15 67.08 62.29 67.08 62.29-29.05 62.29-67.08zM593.16 455.45l34.13-20.67c6.6 11.67 12.59 21.56 26.96 21.56s22.46-5.39 22.46-26.35V287.45h41.92v143.14c0 43.42-25.46 63.19-62.59 63.19-33.54 0-53-17.38-62.88-38.33zM759.03 287.45h134.75v36.83h-92.82V371h81.75v35.94h-81.75v47.32h97.02v36.83H759.03V287.46zM925.5 389.26c0-60.2 46.41-104.21 104.81-104.21 36.84 0 63.19 13.18 81.45 41.62l-32.05 22.76c-9.58-15.57-26.05-26.65-49.41-26.65-36.84 0-61.69 28.45-61.69 66.48s24.85 67.08 61.69 67.08c26.35 0 41.02-12.58 52.41-29.95l32.64 22.46c-17.67 27.55-45.81 44.93-85.05 44.93-58.4 0-104.81-44.32-104.81-104.52zM1192.89 324.28h-58.1v-36.83h158.11v36.83h-58.1v166.8h-41.92v-166.8zM1304.56 450.95l34.14-19.76c8.98 14.68 20.67 25.46 41.33 25.46 17.37 0 28.45-8.69 28.45-20.67 0-14.37-11.39-19.47-30.55-27.85l-10.48-4.49c-30.25-12.87-50.31-29.05-50.31-63.18 0-31.45 23.96-55.4 61.39-55.4 26.65 0 45.81 9.28 59.59 33.54l-32.65 20.96c-7.19-12.88-14.96-17.97-26.94-17.97s-20.07 7.79-20.07 17.97c0 12.58 7.79 17.67 25.75 25.45l10.48 4.5c35.64 15.28 55.71 30.85 55.71 65.88 0 37.73-29.65 58.4-69.47 58.4s-64.09-18.57-76.37-42.83z"
      />
      <path
        fill="none"
        stroke="white"
        strokeMiterlimit={10}
        strokeWidth="14.18px"
        d="M373.38 236.36L537.77 236.36"
      />
    </svg>
  );
}



const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      storyblokEntry(full_slug: { eq: "footer" }) {
        id
        content
      }
    }
  `);

  let story = data.storyblokEntry;

  story = useStoryblok(story);

  const content = story.content;

  const blockLength = content.blocks.length;

  return (
    <footer className="text-footer text-white py-[50px] lg:py-[58px] bg-black">
      <div className="container-theme grid lg:grid-cols-5">
        <div className="flex justify-between flex-col">
          <Link to="/">
            <StackedLogo class="w-[160px]" />
          </Link>
          <p className='hidden lg:inline-block'>
            Site by <Link to="https://www.lbdstudios.com.au/">LBD STUDIOS</Link>
          </p>
        </div>

        {blockLength < 4 && (
          <div
            className={`hidden lg:block ${
              blockLength == 1 ? `lg:col-span-3` : ``
            } ${blockLength == 2 ? `lg:col-span-2` : ``} ${
              blockLength == 3 ? `lg:col-span-1` : ``
            }`}
          ></div>
        )}

        {content.blocks.map((block, index) => {
          if (block.component == "rich_text") {
            return (
              <div className="text-footer text-white pt-[28px] pb-[55px] lg:py-0">
                <p dangerouslySetInnerHTML={{__html: block.copy}}></p>
              </div>
            );
          } else {
            return (
              <div className='flex justify-between flex-col text-footer'>
                <h2 className='pb-[14px] lg:pb-0'>{block.title}</h2>
                <ul>
                  {block.blocks.map((link, index) => {
                    return (
                      <li key={`f-index-${index}`}>
                        <Link to={link.link.cached_url}>{link.title}</Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          }
        })}

        <div className='lg:hidden pt-[55px]'>
        <p>
            Site by <Link to="https://www.lbdstudios.com.au/">LBD STUDIOS </Link>
          </p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
